// Filename - pages/Support.js

import React from "react";

const Report = () => {
    return (
        <div className="Report">
            <h1> Report</h1>
        </div>
    );
};

export default Report;
